import handshake from 'assets/images/composition/handshake-with-yellow-heart.webp';
import {Button, Modal} from 'letrus-ui';
import styles from './StoreRatingModal.module.scss';

interface StoreRatingModalProps {
  storeLink?: string;
  showBothStoresButton?: boolean;
  onClose: () => void;
}

function StoreRatingModal({
  storeLink,
  showBothStoresButton,
  onClose,
}: StoreRatingModalProps): JSX.Element {
  return (
    <Modal id="storeRatingModal" className={styles.modal} closeButton>
      <div className={styles.container}>
        <h3>Que bom que está gostando do nosso app!</h3>

        <p>
          Que tal avaliar também na sua loja de aplicativos? É super rápido e
          muito importante para nós.
        </p>

        <img src={handshake} alt="Nos avalie na loja de aplicativos" />

        {showBothStoresButton ? (
          <div className={styles.buttonAppReviewPopup}>
            <Button
              onClick={() => {
                window.open(
                  'https://play.google.com/store/apps/details?id=br.com.letrus.aluno.twa',
                  '_blank',
                );
                onClose();
              }}
              variant="primary"
              theme="blue"
              type="button"
            >
              Avalie na Play Store
            </Button>
            <Button
              onClick={() => {
                window.open(
                  'https://apps.apple.com/br/app/letrus-estudante/id1663276644',
                  '_blank',
                );
                onClose();
              }}
              variant="primary"
              theme="blue"
              type="button"
            >
              Avalie na Apple Store
            </Button>
          </div>
        ) : (
          <Button
            onClick={() => {
              window.open(storeLink, '_blank');
              if (onClose) onClose();
            }}
            variant="primary"
            type="button"
          >
            Avaliar agora
          </Button>
        )}
      </div>
    </Modal>
  );
}

export default StoreRatingModal;
